import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpModalComponent } from './help-modal.component';

import { MatDialogModule } from '@angular/material/dialog';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';



@NgModule({
	declarations: [ HelpModalComponent ],
	imports: [
		CommonModule,
		FormsModule,
		MatDialogModule,
		PipesModule,
		RouterModule,
		MatIconModule
	],
	exports: [ HelpModalComponent ],

})
export class HelpModalModule { }
